import styled, { css } from 'styled-components';
import { pageToolbarHeight } from 'styles/spacings';
import UnstyledDropdown from 'components/Dropdown';
import { Label as DropdownLabel } from 'components/Dropdown/styles';

import {
	black,
	white,
	grey30,
	grey400,
	grey200,
	grey150,
	brandColors,
	chartDarkGray,
	chartLightGray,
	greenLightest2,
} from 'styles/colors';

export const ScrollContainer = styled.div`
	width: 100%;
	max-width: 100%;
	height: calc(
		100% - ${pageToolbarHeight} - ${props => props.extraHeight || '0px'}
	);
	overflow: auto;
`;

export const PageTitle = styled.div`
	color: ${black};
	font-size: 19px;
	line-height: 27px;
`;

export const PageSection = styled.div`
	max-width: 1200px;
	width: calc(100% - 64px);
	margin: 0 auto;
	padding: 16px 0 24px 0;
	position: relative;

	background: ${({ dark }) => (dark ? chartLightGray : 'unset')};

	@media (max-width: 1264px) {
		margin: 0 32px;
	}
`;

export const FluidSection = styled.div`
	width: 100%;
	padding: 0 32px;
	position: relative;
	background: ${({ dark }) => (dark ? chartLightGray : 'unset')};
`;

export const PageSectionDividor = styled.div`
	background: ${white};
	height: 24px;
	width: 100%;
`;

const HideMixin = css`
	position: absolute !important;
	top: -9999px !important;
	left: -9999px !important;
`;

export const ExportContainer = styled(PageSection)`
	${props => (props.visible ? '' : HideMixin)};
	${({ width }) =>
		!width
			? ''
			: css`
					width: ${width}px;
					max-width: ${width}px;
					min-width: ${width}px;
			  `};
`;

export const DevHide = styled.div`
	display: none;
`;

export const PageSectionPreview = styled(PageSection)`
	margin: 0 auto;
	height: 950px;
	max-height: 950px;
	display: flex;
	flex-direction: column;

	&:last-child {
		margin-bottom: 24px;
	}
`;

export const PageSectionTitle = styled.div`
	height: 31px;
	color: ${black};
	font-size: 23px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 31px;
`;

export const PageSectionDescription = styled.div`
	height: 45px;
	padding: 9px 8px;
	width: 100%;
	margin: 22px auto 0;
	background-color: ${grey150};
	color: ${black};
	font-size: 19px;
	font-weight: 500;
	line-height: 27px;
`;

export const TopRightContentHolder = styled.div`
	border: none;
	margin: 0;
	padding: 0;
	width: auto;
	overflow: visible;
	position: absolute;
	right: ${({ isFluid }) => (isFluid ? '33px' : '-15px')};
	top: 4px;
	cursor: pointer;
	fill: ${grey400};
	outline: none;
	font-size: 23px;
	display: flex;

	&:hover {
		fill: ${grey200};
	}
`;

export const SlideTitle = styled.div`
	color: ${brandColors.green};
	font-family: Roboto;
	font-size: 23px;
	font-weight: 500;
	letter-spacing: 0.3px;
	line-height: 31px;
	margin: 16px auto;
	max-width: 1200px;
`;

export const SlideHeader = styled.div`
	color: ${black};
	font-size: 28px;
	font-weight: bold;
	letter-spacing: 0.3px;
	line-height: 33px;
`;

export const SlideNote = styled.div`
	color: ${chartDarkGray};
	font-family: Roboto;
	font-size: 16px;
	letter-spacing: 0.3px;
	line-height: 24px;
	margin: 16px 0;
`;

export const SlideFooter = styled.div`
	display: flex;
	flex-direction: row;
	margin: 16px 0 0;
	justify-content: space-between;
	align-items: center;
	flex-shrink: 0;
`;

export const SlideDelimiter = styled.div`
	width: 100%;
	height: 1px;
	background-color: ${brandColors.green};
`;

export const SlideFooterLogo = styled.div`
	& .ap-logo {
		width: 108px;
	}
`;

export const SlideFooterPageNumber = styled.div`
	color: ${chartDarkGray};
	font-family: Roboto;
	font-size: 16px;
	letter-spacing: 0.3px;
	line-height: 24px;
`;

export const SlideFooterText = styled.div`
	color: ${chartDarkGray};
	font-family: Roboto;
	font-size: 16px;
	letter-spacing: 0.3px;
	line-height: 24px;
`;

export const SlidePreviewContent = styled.div`
	flex: 1 0 auto;
`;

export const SlideInfo = styled.div`
	height: 45px;
	width: 100%;
	background-color: #e6e6e6;
	color: ${black};
	font-size: 19px;
	font-weight: 500;
	line-height: 27px;
	display: flex;
	align-items: center;
	padding: 0 8px;
	margin: 24px 0;
`;

export const CurrencyUnitsSelectWrapper = styled.div`
	margin-left: auto;
	margin-right: 20px;
	position: relative;
	z-index: 2;
`;

export const ColumnsBackgroundContainer = styled.div`
	background: ${grey30};
	display: flex;
	flex-direction: column;
	overflow: hidden;
	min-height: 200px;
	padding-bottom: 32px;
`;

export const ColumnsBackgroundInnerWrapper = styled.div`
	background: ${white};
	box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
	width: calc(100% - 64px);
	margin: 32px auto;
	max-width: 1200px;
`;

export const Dropdown = styled(UnstyledDropdown)`
	padding: 0 7px;
	margin: 0;

	${DropdownLabel} {
		padding: 0;
		font-size: 13px;
		font-weight: 500;
		letter-spacing: 0.3px;
		color: inherit;
	}

	div > ${DropdownLabel} {
		padding: 0 20px;
	}
`;

export const HeaderSeparator = styled.div`
	height: 24px;
	width: 1px;
	background-color: ${grey150};
	margin: 13px -1px 0 0;
`;

export const NavLabel = styled.div`
	font-size: 16px !important;
	line-height: 24px;
	letter-spacing: 0.3px;
	color: ${chartDarkGray};
	margin-right: 20px;
	${props =>
		props.active &&
		`color: ${black};
		font-weight: 500;
		`};

	${props =>
		props.disabled &&
		`color: ${grey200};
		`};
`;

export const LabelHelper = styled.div`
	display: inline;
	font-size: 11px;
	margin-left: auto;
	letter-spacing: 0.3px;
	color: ${chartDarkGray};
	align-self: center;
	${props =>
		props.active &&
		`color: ${black};
		font-weight: 500;
		`};
`;

export const Row = styled.div`
	display: flex;
	flex-direction: row;
`;

export const Divider = styled.div`
	border-left: 1px solid #e6e6e6;
	height: 24px;
	margin-left: 10px;
	margin-top: 12px;
	align-self: center;
	display: inline-block;
`;

export const LabelText = styled.span`
	text-transform: uppercase;
	font-size: 13px;
	color: ${black};
`;

export const SubnavButton = styled.button`
	text-align: left;
	border: 0;
	outline: none;
	display: block;
	padding: 8px 24px 8px 16px;
	width: 100%;
	color: ${black};
	transition: background-color 100ms ease-out;

	&:first-of-type {
		margin-top: 8px;
	}

	&:last-of-type {
		margin-bottom: 8px;
	}

	&:not(:disabled) {
		cursor: pointer;
	}

	&:disabled {
		color: ${grey400};
	}

	@media (hover: hover) {
		&:not(:disabled):hover {
			background-color: ${greenLightest2};
		}
	}
`;
